<template>
  <hm-content title="预约订单列表" ref="hmcontent">
    <div class="table-panel flex flex-end">
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="报名开始时间"
        end-placeholder="报名结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
        clearable
      ></el-date-picker>
      <el-date-picker
        v-model="searchCondition.chargeDate"
        type="datetimerange"
        align="right"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="核销开始时间"
        end-placeholder="核销结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="mr10"
        clearable
      ></el-date-picker>
      <el-input
          clearable
          v-model.trim="searchCondition.orderSn"
          placeholder="请输入订单号"
          size="small"
          class="ipt mr10"
      ></el-input>
      <el-input
          clearable
          v-model.trim="searchCondition.actName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
      ></el-input>
      <!-- <el-select
        clearable
        v-model="searchCondition.subActId"
        placeholder="请选择活动名称"
        size="small"
        filterable
        class="mr10"
        @change="subActChange"
      >
        <el-option
          :label="v.actName"
          :value="v.id"
          v-for="(v, i) in allActiveList"
          :key="i"
        ></el-option>
      </el-select> -->
      <!-- <el-select
        clearable
        :disabled="!searchCondition.subActId"
        v-model="searchCondition.actSite"
        placeholder="选择场地"
        @change="selectAddress"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          :label="v.actSite"
          :value="v.actSite"
          v-for="(v, i) in siteList"
          :key="i"
        ></el-option>
      </el-select> -->
      <!-- <el-select
        :disabled="!searchCondition.actSite"
        clearable
        v-model="searchCondition.subRoundId"
        placeholder="选择场次"
        size="small"
        filterable
        class="mr10"
      >
        <el-option
          :label="v.actRound"
          :value="v.id"
          v-for="(v, i) in roundList"
          :key="i"
        ></el-option>
      </el-select> -->
      <el-input
        clearable
        v-model.trim="searchCondition.queryMemberValue"
        placeholder="请输入"
        size="small"
        style="width:300px"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          style="width:100px"
          v-model="searchCondition.queryMemberType"
          size="small"
        >
          <el-option label="会员名称" value="memberName"></el-option>
          <el-option label="会员手机号" value="memberMobile"></el-option>
        </el-select>
      </el-input>
      <el-input
        clearable
        v-model.trim="searchCondition.queryShareMemberValue"
        placeholder="请输入"
        size="small"
        style="width:300px"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          style="width:100px"
          v-model="searchCondition.queryShareMemberType"
          size="small"
        >
          <el-option label="分享人名称" value="memberName"></el-option>
          <el-option label="分享人手机号" value="memberMobile"></el-option>
        </el-select>
      </el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" @click="output" size="small">导出</el-button>
    </div>
    <div class="table-panel">
      <el-radio-group
        v-model="searchCondition.orderStatus"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="">全部({{ allNum }})</el-radio-button>
        <el-radio-button label="1">已报名({{ appliedNum }})</el-radio-button>
        <el-radio-button label="3">已完成({{ completedNum }})</el-radio-button>
        <el-radio-button label="2">已取消({{ canceledNum }})</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="orderSn"
          align="center"
          label="订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="actName"
          align="center"
          label="活动名称"
        >
        </el-table-column>
         <el-table-column
          header-align="center"
          align="center"
          prop="selectedShopName"
          label="核销门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="用户名"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="报名时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="联系方式"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="suitPerson"
          label="收费模式"
        >
          <template slot-scope="scope">
            {{ scope.row.actCostMoney }}元+{{ scope.row.actCostIntegral }}积分
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="authCode"
          label="核销码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actSite"
          label="活动地址"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actRound"
          label="活动场次"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberName"
          label="分享人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberMobile"
          label="分享人手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="分享人所属门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderStatus"
          label="订单状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.orderStatus === '1'" class="success">
              已报名
            </div>
            <div v-else-if="scope.row.orderStatus === '2'" class="gray">
              已取消
              <div v-if="scope.row.oaMemo" class="danger" @click="showDialogOfflineOrderRefund(scope.row)">线下退款</div>
            </div>
            <div v-else-if="scope.row.orderStatus === '3'" class="success">
              已完成
            </div>
            <div v-else-if="scope.row.orderStatus === '99'" class="danger">
              未付款
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="chargeStatus"
          label="核销状态"
        >
          <template slot-scope="scope">
            <div :class="scope.row.chargeStatus === '0' ? 'gray' : 'success'">
              {{ scope.row.chargeStatus === "0" ? "待核销" : "已核销" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="chargeName"
            label="核销人"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="chargeUserName"
            label="核销人名称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="chargeTime"
            label="核销时间"
        >
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.chargeStatus == 0"
              type="text"
              size="small"
              :disabled="scope.row.orderStatus === '2'"
              @click="openWriteOff(scope.row)"
              >核销</el-button
            >
            <el-button
              v-else-if="scope.row.chargeStatus == 1"
              type="text"
              size="small"
              @click="remove(scope.row, '不核销', 0)"
              >不核销</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="offlineOrderRefund(scope.row)"
              v-if="scope.row.orderStatus === '1' && scope.row.isShowOfflineOrderRefund"              
              >线下退款</el-button
            >
            <el-button
              :disabled="scope.row.orderStatus !== '1'"
              type="text"
              size="small"
              @click="refund(scope.row)"
              v-else
              >退款</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="更改线下已退款订单状态"
      :close-on-click-modal="false"
      :visible.sync="dialogOfflineOrderRefund"
    >
      <div class="mb10" v-if="!operateTimeOfflineOrderRefund">您要申请更改“订单号：{{receiptSnRow}}”的状态？</div>
      <div class="mb10 danger" v-if="!operateTimeOfflineOrderRefund">注意 当前的操作针对的是线上超过3个月的订单，线下已经申请退款需要修改线上订单状态(不涉及积分和优惠券退还)，请审核无误后上传线下已经退款的凭据，请勿随意操作！！</div>
      <el-form
        :model="ruleFormOfflineOrderRefund"
        :rules="rulesOfflineOrderRefundrules"
        ref="ruleFormOfflineOrderRefund"
        label-width="150px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="退款凭证:" prop="pic">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormOfflineOrderRefund.pic"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="priview" v-if="ruleFormOfflineOrderRefund.pic">
              <el-image
                class="image"
                :src="ruleFormOfflineOrderRefund.pic"
                alt="主图"
                :preview-src-list="[ruleFormOfflineOrderRefund.pic]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="!operateTimeOfflineOrderRefund">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mb10" label="备注:" prop="remark">
            <el-input
              style="height:100%"
              class="remark-tarea"
              size="small"
              type="textarea"
              clearable
              placeholder="请输入商品备注"
              maxlength="128"
              v-model="ruleFormOfflineOrderRefund.remark"
              :disabled="disabledRemark"
            ></el-input>
          </el-form-item>
          <el-form-item class="mb10" label="操作时间:" prop="operateTime" v-if="operateTimeOfflineOrderRefund">
            <div>{{operateTimeOfflineOrderRefund}}</div>
          </el-form-item>
          <el-form-item class="mb10" label="操作人:" prop="operateName" v-if="operateNameOfflineOrderRefund">
            <div>{{operateNameOfflineOrderRefund}}</div>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitFormOfflineOrderRefund('ruleFormOfflineOrderRefund')" v-if="!operateTimeOfflineOrderRefund"
            >提交</el-button
          >
          <el-button size="small" @click="dialogOfflineOrderRefund = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 预约活动核销选择门店弹框 -->
    <verify-shop-dialog
      ref="verifyShopDialogRef"
      :store-code="storeCode"
      @confirmed="onShopConfirmed"
      @fallback="onShopFallback"
    />
  </hm-content>
</template>

<script>
import moment from 'moment'
import { getLoginUser } from "@/utils/auth";
import VerifyShopDialog from "@/components/VerifyShopDialog.vue";
export default {
  components: {
    VerifyShopDialog
  },
  data() {
    const patternListHeader = function(rule, val, callback) {
      if (!this.ruleFormOfflineOrderRefund.pic) {
        return callback(new Error("请上传退款凭证"));
      }
      callback();
    }.bind(this);
    return {
      allNum: 0,
      appliedNum: 0,
      completedNum: 0,
      canceledNum: 0,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        orderStatus: "",
        subActId: "",
        subRoundId: "",
        actSite: "",
        queryMemberType: "memberName",
        queryShareMemberType: "memberName",
        orderSn: "",
        actName: "",
        applyDate: [],
        chargeDate: [],
      },
      // allActiveList: [],
      roundList: [],
      siteList: [],
      id: "",
      dialogOfflineOrderRefund: false,
      ruleFormOfflineOrderRefund: {
        pic: "",
        remark: "",
      },
      rulesOfflineOrderRefundrules: {
        pic: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
      },
      uploadShow: true,
      receiptSnRow: "",
      operateTimeOfflineOrderRefund: "",
      operateNameOfflineOrderRefund: "",
      disabledRemark: false,
      diffDay: 0,
      // 核销选择门店相关
      storeCode: "",
    };
  },
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
  },
  mounted() {
    // this.queryAllActiveList();
    const startTime = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.applyDate = [startTime, endTime];
    this.queryList();
    this.getParamValueAllowNull();
  },
  methods: {
    async output() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.applyDate && this.searchCondition.applyDate.length > 0 ? this.searchCondition.applyDate[0] : null;
      searchCondition.queryEndTime =
        this.searchCondition.applyDate && this.searchCondition.applyDate.length > 0 ? this.searchCondition.applyDate[1] : null;
      searchCondition.chargeStartTime =
        this.searchCondition.chargeDate && this.searchCondition.chargeDate.length > 0 ? this.searchCondition.chargeDate[0] : null;
      searchCondition.chargeEndTime =
        this.searchCondition.chargeDate && this.searchCondition.chargeDate.length > 0 ? this.searchCondition.chargeDate[1] : null;
      delete searchCondition.chargeDate;
      await this.$store.dispatch("subApplyOrderListExport", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    subActChange(val) {
      this.searchCondition.actSite = "";
      this.searchCondition.subRoundId = "";
      if (val) {
        this.id = val;
        this.queryActivityDetails();
      }
    },
    async queryActivityDetails() {
      const { result } = await this.$store.dispatch("subActivityDetails", {
        id: this.id
      });
      this.siteList = result.roundBo;
      console.log("result: ", result);
    },
    selectAddress() {
      this.roundList = this.searchCondition.actSite
        ? this.siteList.find(p => p.actSite === this.searchCondition.actSite)
            .subscribeRound
        : [];
      this.searchCondition.subRoundId = "";
    },
    refund(row) {
      this.$confirm("确定是否退款", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store
            .dispatch("subApplyRefund", {
              id: row.id
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 打开核销门店选择弹框
    openWriteOff(row) {
      this.$refs.verifyShopDialogRef.openShop(row);
    },
    // 核销成功后刷新列表
    onShopConfirmed() {
      this.queryList();
    },
    // 未配置门店信息，走原核销流程
    onShopFallback(row) {
      this.remove(row, "要核销", 1);
    },
    remove(row, txt, status) {
      this.$confirm(
        "确定" + txt + "此预约信息？注：请仔细确认会员信息",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$store
            .dispatch("chargeFromId", {
              id: row.id,
              chargeStatus: status
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    // async queryAllActiveList() {
    //   const { result } = await this.$store.dispatch("allSubActivityList", {
    //     pageSize: 999999,
    //     pageNo: 1
    //   });
    //   this.allActiveList = result.activityList.records;
    // },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      params.queryStartTime =
        this.searchCondition.applyDate && this.searchCondition.applyDate.length > 0 ? this.searchCondition.applyDate[0] : null;
      params.queryEndTime =
        this.searchCondition.applyDate && this.searchCondition.applyDate.length > 0 ? this.searchCondition.applyDate[1] : null;
      params.chargeStartTime =
        this.searchCondition.chargeDate && this.searchCondition.chargeDate.length > 0 ? this.searchCondition.chargeDate[0] : null;
      params.chargeEndTime =
        this.searchCondition.chargeDate && this.searchCondition.chargeDate.length > 0 ? this.searchCondition.chargeDate[1] : null;
      delete searchCondition.chargeDate;
      // searchCondition.startDate =
      //   this.searchCondition.createTimeArry &&
      //   this.searchCondition.createTimeArry.length > 0
      //     ? this.searchCondition.createTimeArry[0]
      //     : null;
      // searchCondition.endDate =
      //   this.searchCondition.createTimeArry &&
      //   this.searchCondition.createTimeArry.length > 0
      //     ? this.searchCondition.createTimeArry[1]
      //     : null;
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "querySubApplyOrderList",
        params
      );
      if (code === "0") {
        for (let key in result) {
          if (key !== "pageList") {
            this[key] = result[key];
          }
        }
        const { pageList } = result;

        const { total, records } = pageList;
        this.list = records;
        this.total = total;
        this.list.forEach(v => {
          console.log("this.dateDiff(v.createTime)>this.diffDay:",this.dateDiff(v.createTime)>=this.diffDay);
          if(v.createTime && this.dateDiff(v.createTime)>=this.diffDay){
              v.isShowOfflineOrderRefund = true;
          }
        });
        console.log("this.list:",this.list);
      }
    },
    dateDiff(setDay) {
      //sDate1和sDate2是2006-12-18格式
      let aDate, oDate1, oDate2, iDays;
      aDate = setDay.split(" ")[0].split("-"); //调用Date的构造函数，转换为12-18-2006格式
      oDate1 = new Date(aDate[0], aDate[1] - 1, aDate[2]);
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = "0" + date.month;
      }
      if (date.date >= 0 && date.date <= 9) {
        date.date = "0" + date.date;
      }
      oDate2 = oDate2 = new Date(date.year, date.month - 1, date.date); //把相差的毫秒数转换为天数
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
      return iDays;
    },
    offlineOrderRefund(v) {
      this.receiptSnRow = v.orderSn;
      this.ruleFormOfflineOrderRefund.pic = "";
      this.ruleFormOfflineOrderRefund.remark = "";
      this.operateNameOfflineOrderRefund = "";
      this.operateTimeOfflineOrderRefund = "";
      this.disabledRemark = false;
      this.dialogOfflineOrderRefund = true;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormOfflineOrderRefund.pic = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleFormOfflineOrderRefund.pic = "";
    },
    // 提交
    async submitFormOfflineOrderRefund(formName){
          const result = await this.$confirm(
            "请核实当前的订单是否正确，您是否上传了线下退款凭证，确认无误后再操作！",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          );
          if (result === "confirm") {
            this.$refs[formName].validate(valid => {
            if (valid) {
              let params = {
                orderSn: this.receiptSnRow,
                pic: this.ruleFormOfflineOrderRefund.pic,
                remark: this.ruleFormOfflineOrderRefund.remark,
              }
              console.log("params:",params);
              // return false;
              this.$store.dispatch("overdueApplyRefundUpdateOAOperateResult",params).then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.dialogOfflineOrderRefund = false;
                  this.queryList();
                }
              });
            }
          })
      }
    },
    async getParamValueAllowNull() {
      console.log("getParamValueAllowNull");
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "pas_subscribe_apply_refund_overdue_days"
      })
      if (code === "0") {
        console.log("result.paramValue",result.paramValue);
        this.diffDay = result.paramValue || 90;
      }
    },
    showDialogOfflineOrderRefund(row){
      this.receiptSnRow = row.orderSn;
      this.ruleFormOfflineOrderRefund = JSON.parse(row.oaMemo);
      console.log("this.ruleFormOfflineOrderRefund:",this.ruleFormOfflineOrderRefund);
      this.operateNameOfflineOrderRefund = this.ruleFormOfflineOrderRefund.operatorUsername;
      this.operateTimeOfflineOrderRefund = this.ruleFormOfflineOrderRefund.operateTime;
      this.disabledRemark = true;
      this.dialogOfflineOrderRefund = true;
    },
  }
};
</script>

<style scoped lang="scss">
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  .image {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
